import { useState } from 'react';
import ChartsSection from '../../components/charts-section/charts-section.component';
import DeviceMap from '../../components/device-map/device-map.component';
import MessageSection from '../../components/message-section/message-section.component';
import './dashboard-home.styles.css';
import { FiRefreshCw } from "react-icons/fi";

const DashboardHome = () => {
  const [lastUpdate, setLastUpdate] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [tableData, setTableData] = useState([]);

  const handleLastUpdate = (date) => {
    setLastUpdate(date);
  };

  const handleDates = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  const handleTableData = (data) => {
    setTableData(data);
  };

  return (
    <div className='dashboard-home-wrapper'>
      <div className='container'>
        <h1 className='page-title'>{process.env.REACT_APP_DEVICE_ID}</h1>
        <div className='page-sub-title-wrapper'>
          <p className='page-text'>Last Update: {lastUpdate}</p>
          <button className='dashboard-refresh-button'>
            <FiRefreshCw />
            refresh
          </button>
        </div>
        <DeviceMap handleLastUpdate={handleLastUpdate} startDate={startDate} endDate={endDate} />
        <ChartsSection handleDates={handleDates} handleTableData={handleTableData} />
        <MessageSection tableData={tableData} />
      </div>
    </div>
  )
}

export default DashboardHome